<template>
  <section>
    <qx-tab
      v-if="tabs.length !== 0"
      :tabs="tabs"
      v-model="activeTab"
      @cc="handleTabChange"
    />
    <qx-card title="订单信息" v-show="activeTab === '6'">
      <!-- 订单详情数据 -->
      <qx-detail-box :data="orderInfo" :colNum="3" />
      <!-- 订单详情数据 end -->
    </qx-card>
    <qx-card title="订单信息" v-show="activeTab === '8'">
      <!-- 订单详情数据 -->
      <qx-detail-box :data="orderInfo" :colNum="3" />
      <!-- 订单详情数据 end -->
    </qx-card>
    <qx-card title="订单信息" v-show="activeTab === '3'">
      <!-- 订单详情数据 -->
      <qx-detail-box :data="orderInfo" :colNum="3" />
      <!-- 订单详情数据 end -->
    </qx-card>
    <!-- 订单详情 -->
    <OrderDetail ref="orderDetail" v-show="activeTab === '0'" />
    <!-- 异常登记 -->
    <Unusual ref="unusual" v-show="activeTab === '5'" />
    <!-- 时效罚款 -->
    <Prescription
      ref="prescription"
      v-show="activeTab === '7'"
    />

    <Carrier ref="carrier" v-show="activeTab === '1'" />
    <Customer ref="customer" v-show="activeTab === '2'" />
    <Report ref="report" v-show="activeTab === '3'" />
    <Driver ref="driver" v-show="activeTab === '4'" />
    <!-- 驾驶记录 -->
    <DrivingRecord ref="drivingRecord" v-show="activeTab === '8'" />
    <!-- 操作日志 -->
    <Log ref="log" v-show="activeTab === '6'" />
  </section>
</template>

<script>
import OrderDetail from './orderDetail/orderDetail.vue';
import Unusual from './unusual/unusual.vue';
import Prescription from './prescription/prescription';
import Log from './log/log.vue';
import DrivingRecord from './drivingRecord/drivingRecord.vue';

import Carrier from './carrier/carrier.vue';
import Customer from './customer/customer.vue';
import Report from './report/report.vue';
import Driver from './driver/driver.vue';

import {
  orderOverviewDetail,
} from 'api/operate';
export default {
  components: {
    OrderDetail,
    Unusual,
    Prescription,
    Log,
    Carrier,
    Customer,
    Report,
    Driver,
    DrivingRecord,
  },
  data () {
    return {
      activeTab: this.$route.query.tar || '0',
      orderInfo: {
        label: '基本信息',
        tableData: {
          title: [
            {
              prop: 'orderId',
              label: '订单编号',
            },
            {
              prop: 'statusName',
              label: '订单状态',
            },
            {
              prop: 'orderTypeName',
              label: '订单来源',
            },
          ],
          data: {

          },
          approveData: {

          },
        },
      },
    };
  },
  computed: {
    tabs () {
      if (this.$route.query.isHandle && this.$route.query.tar === '1') {
        return [
          {
            label: '承运方时效罚款',
            value: '1',
          },
          {
            label: '客户时效罚款',
            value: '2',
          },
          {
            label: '报备',
            value: '3',
          },
        ];
      } else if (this.$route.query.isHandle && this.$route.query.tar === '5') {
        return [];
      } else {
        return [
          {
            label: '订单详情',
            value: '0',
          },
          {
            label: '异常登记',
            value: '5',
          },
          {
            label: '时效罚款',
            value: '7',
          },
          // {
          //   label: '承运方时效罚款',
          //   value: '1',
          // },
          // {
          //   label: '客户时效罚款',
          //   value: '2',
          // },
          {
            label: '报备记录',
            value: '3',
          },
          // {
          //   label: '司机更换记录',
          //   value: '4',
          // },
          {
            label: '驾驶记录',
            value: '8',
          },
          {
            label: '操作日志',
            value: '6',
          },
        ];
      }
    },
  },
  methods: {
    handleTabChange (activeTab) {
      this.$nextTick(() => {
        switch (activeTab) {
          case '0':
            this.$refs.orderDetail.getData();
            break;
          case '1':
            this.$refs.carrier.getData();
            break;
          case '2':
            this.$refs.customer.getData();
            break;
          case '3':
            this.$refs.report.getData();
            break;
          case '5':
            this.$refs.unusual.getData();
            break;
          case '6':
            this.$refs.log.getData();
            break;
          case '7':
            this.$refs.prescription.getData();
            break;
          case '8':
            this.$refs.drivingRecord.getData();
            break;
          default:
            break;
        }
      });
    },
    getData () {
      if (this.$route.path !== '/manage/operate/order/deal/orderDetailTab' || !this.$route.query.id) {
        return;
      }
      orderOverviewDetail({
        orderId: this.$route.query.id,
      }).then((res) => {
        if (!res.failed) {
          this.orderInfo.tableData.data = res;
        }
      });
      // 正常页签由 qx-tab 的初始化/点击事件加载，避免 mounted 再重复请求；
      // 无页签的异常处理模式仍需由父组件主动加载当前内容。
      if (this.tabs.length === 0) {
        this.handleTabChange(this.activeTab);
      }
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
    '$route.query.isVerity': function () {
      this.getData();
    },
    '$route.query.tar': function () {
      this.activeTab = this.$route.query.tar || '0';
      if (this.tabs.length === 0) {
        this.handleTabChange(this.activeTab);
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style>
</style>
